import { ChipPos, RawChipPos } from "@/types/chipPos";
import { mapRawToMask } from "./mask";

export const mapRawToChipPos = (raw: RawChipPos): ChipPos => {
  return {
    id: raw.id,
    name: raw.name,
    mask: mapRawToMask(raw.mask),
    data: raw.data,
  };
};
